export default require('../../client/birth/QuestionsPage').default;
